import React, { useState, useEffect } from 'react'
import { HeaderImport } from './Import'
import "../../i18n/i18n"
const { RoutesMap, ListCollapse, SessionManager, useDispatch, KeyRound, Power, UserPen, UserCog, MoveRight, Languages, useNavigate, Dropdown, Logo, FlagIcon, ConfigProvider, Select, Search, useSelector, dayjs, useTranslation, companyDetailsTodo, company_details, grnStockListTodo } = HeaderImport

// Separate Clock component to isolate time updates
function Clock() {
    const [time, setTime] = useState(dayjs().format('HH:mm:ss'))
    useEffect(() => {
        const interval = setInterval(() => {
            setTime(dayjs().format('HH:mm:ss'))
        }, 1000)
        return () => clearInterval(interval)
    }, [])
    return (
        <span className='text-dark fw-medium d-none d-sm-inline' style={{ fontSize: '13px', whiteSpace: 'nowrap' }}>🕒 {time}</span>
    )
}

export default function Header(props) {

    const { collapsed, setCollapsed, drawerOpen, setDrawerOpen, isMobileOrTablet } = props
    // Time is now handled by the Clock component
    const { t, i18n } = useTranslation();
    const [date, setDate] = useState(new Date().toDateString())

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const data = useSelector(state => state?.sidebar?.data?.sidebarList)
    const asset = useSelector(state => state && state.grnStockList?.data)
    const user_data = JSON.parse(SessionManager.getSession('user'))
    const company_details = useSelector(state => state && state.companyDetails?.data)


    const asset_option = asset?.map?.(val => (
        { "value": val.id, "label": val.item_code, "label2": val.itemMaster?.name || "" }
    ))

    const logout = () => {
        localStorage.clear()
        navigate(RoutesMap.LOGIN.path)
    }

    useEffect(() => {
        dispatch(companyDetailsTodo({ id: user_data?.company_id, navigate }))
        dispatch(grnStockListTodo({ navigate }))
    }, [])


    return (
        <>
            <nav className={collapsed ? "navbar navbar_body_collapsed fixed-top" : "navbar navbar_body_notcollapsed fixed-top"} >
                {/* <nav className="navbar navbar_body fixed-top" > */}
                <div className="container-fluid d-flex flex-nowrap align-items-center gap-2 gap-md-3 px-2 px-md-3">
                    {/* <div className="navbar-brand navbar-logo">
                        <img src={Logo} className='img-fluid login_bg_max' alt="logo" />
                    </div> */}
                    <span className="navbar-brand d-flex align-items-center flex-shrink-0">
                        <ListCollapse
                            onClick={() => {
                                if (isMobileOrTablet) {
                                    setDrawerOpen(!drawerOpen)
                                } else {
                                    setCollapsed(!collapsed)
                                }
                            }}
                            style={{ cursor: 'pointer' }}
                        />
                        <span className='d-none d-sm-flex flex-column ms-2 ms-md-3'>
                            <span style={{ fontSize: '11px' }} className="fw-bold">Welcome, {user_data ? `${user_data.first_name || ""} ${user_data.last_name || ""}` : "Guest"}!!</span>
                            <span style={{ fontSize: '9px' }} className='text-secondary d-none d-md-block'>{date}</span>
                        </span>
                    </span>

                    <div className='flex-grow-1 d-flex align-items-center min-w-0'>
                        <div className='w-100'>
                            <ConfigProvider
                                theme={{
                                    components: {
                                        Select: {
                                            borderColor: 'hsl(0, 0%, 80%)',
                                            selectorBg: 'rgba(255,255,255,0.7)',
                                            activeBorderColor: '#0D6EFD',
                                            activeOutlineColor: 'none',
                                            hoverBorderColor: 'none',
                                            optionPadding: '0px',
                                            optionSelectedColor: '#33372c',
                                            optionSelectedBg: 'none',
                                            // optionActiveBg: '#FEF4EA',
                                            zIndexPopup: '99999'
                                        },
                                    },
                                    token: {
                                        colorBorder: '#ccc',
                                        fontFamily: 'Lexend Deca'
                                    },
                                }}
                            >
                                <Search
                                    showSearch
                                    allowClear
                                    size='middle'
                                    mode="single"
                                    placeholder={'Search Asset'}
                                    className='custom-select-place'
                                    options={asset_option}
                                    optionRender={(option) => (
                                        <div className='p-2 mb-1 bg-body-secondary rounded'>
                                            {/* <div className='fw-medium text-primary-emphasis'>
                                                 <MoveRight size={16} className='ms-1 me-1' /> <span className='text-secondary'>{option.data.sub}</span> <MoveRight size={16} className='ms-1 me-1' /> <span className='text-success'>{option.data.label}</span>
                                            </div>
                                            <span className='text-danger'>({option.data.label})</span> */}
                                            <div className='fw-medium text-primary-emphasis d-flex align-items-center flex-nowrap' style={{ whiteSpace: 'nowrap', fontSize: 'clamp(9px, 3vw, 14px)' }}>
                                                <MoveRight size={16} className='ms-1 me-1 mb-1 flex-shrink-0' />
                                                <p className='text-success mb-0 flex-shrink-1 text-truncate'>{option.data.label2}</p>
                                                <span className='text-secondary ms-2 mb-0 flex-shrink-0'>( {option.data.label} )</span>
                                            </div>
                                        </div>
                                    )}

                                    filterOption={(input, option) => {
                                        const searchText = input.toLowerCase();

                                        const labelMatch = String(option?.label ?? "")
                                            .toLowerCase()
                                            .includes(searchText);

                                        const valueMatch = String(option?.value ?? "")
                                            .toLowerCase()
                                            .includes(searchText);

                                        const label2Match = String(option?.label2 ?? "")
                                            .toLowerCase()
                                            .includes(searchText);

                                        return labelMatch || valueMatch || label2Match;
                                    }}

                                    // name={name}
                                    // value={value}
                                    onChange={(e) =>
                                        navigate(RoutesMap.ASSET_DETAILS.path, { state: e })
                                        // console.log('fun',e)
                                    }
                                    // onSearch={onInputChange}
                                    // onFocus={onChange}
                                    // onBlur={onBlur}
                                    // onClear={onClear}

                                    style={{
                                        width: '100%',
                                        // borderRadius: '8px'
                                    }}
                                />
                            </ConfigProvider>
                        </div>
                    </div>

                    <div className='d-flex align-items-center flex-shrink-0 gap-1 gap-md-2'>
                        <Clock />
                        <span className='text-secondary d-none d-sm-inline'>|</span>
                        <Languages size={20} style={{ cursor: 'pointer', flexShrink: 0 }} className='d-flex align-items-center'
                            onClick={() => i18n?.language === 'en' ? i18n.changeLanguage("fil") : i18n.changeLanguage("en")}
                        />
                        {company_details?.company_name && (
                            <>
                                <span className='text-secondary d-none d-md-inline'>|</span>
                                <span className='fw-medium d-none d-md-inline d-flex align-items-center' style={{ fontSize: '13px', color: '#ff5040' }}>
                                    <img src={company_details?.company_logo ? process.env.REACT_APP_IMAGE_URL + company_details?.company_logo : ''} alt="Company Logo" className='img-fluid' style={{ height: '15px', width: 'auto', objectFit: 'cover', borderRadius: '4px' }} />
                                </span>
                                <span className='text-secondary d-none d-md-inline'>|</span>
                            </>
                        )}

                        <Dropdown>
                            <Dropdown.Toggle
                                variant=""
                                size='sm'
                                className='p-0 border-0 bg-transparent'
                            // style={{ color: 'white' }}
                            >
                                <img src="./profile.jpg" alt="admin" className='img-fluid admin_img' />
                                {/* <UserCog size={16} className='mb-1 me-1' /> */}
                            </Dropdown.Toggle>

                            <Dropdown.Menu style={{ fontSize: '13px' }} align={localStorage.getItem('lang_key') == 'ar' ? 'start' : 'end'}>
                                <Dropdown.Item href="">
                                    <UserPen size={16} className='mb-1 me-1' /> Profile</Dropdown.Item>
                                <Dropdown.Item href="">
                                    <KeyRound size={16} className='mb-1 me-1' /> Change Password</Dropdown.Item>
                                <hr className='hr_line' />
                                <Dropdown.Item href="" onClick={() => logout()}>
                                    <Power size={16} className='me-1' /> Log Out</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </nav>
        </>
    )
}
